import { useQuery } from '@hooks/reactQuery';

import { getPortalTasksAssignees } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_TASKS_ASSIGNEES } from '@constants/queryKeys';

interface IUseQueryPortalTasksAssigneesReturned {
	portalTasksAssignees: TNameTitleValueLabel[];
	isLoadingPortalTasksAssignees: boolean;
}

export const useQueryPortalTasksAssignees = (projectId?: string): IUseQueryPortalTasksAssigneesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TASKS_ASSIGNEES, projectId],
		queryFn: extractQueryParams(getPortalTasksAssignees),
		select: requestTypes => projectUsersFormatted(requestTypes),
		enabled: [!!projectId],
		...refetchOptions,
	});

	return {
		portalTasksAssignees: data || [],
		isLoadingPortalTasksAssignees: isLoading || isFetching,
	};
};
